import { ChangeEvent } from 'react';
import '../../styles/reusable/Dropdown.css';

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  options: DropdownOption[];
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const Dropdown = ({
  label,
  name,
  value,
  onChange,
  options,
  placeholder = 'Select an option',
  required = false,
  disabled = false,
  className = '',
}: DropdownProps) => {
  return (
    <div className={`reusable-dropdown-group ${className}`}>
      <label htmlFor={name} className="reusable-dropdown-label">
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      <div className="reusable-dropdown-wrapper">
        <select
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className="reusable-dropdown-select"
        >
          <option value="">{placeholder}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="dropdown-arrow">▼</div>
      </div>
    </div>
  );
};

export default Dropdown;
